class Testimonials extends DrupalBehavior {
  onContent(context) {
    once('testimonialSlider', '.testimonials', context).forEach((testimonials) => {
      const items = testimonials.querySelector('.testimonials--items');
      if (items) {
        this.initSlider(items);
      }
    });
  }

  initSlider(element) {
    const items = element.querySelectorAll('.testimonial-item');
    if (items.length == 1) {
      return;
    }
    items.forEach((item) => {
      item.classList.add('keen-slider__slide');
    })
    items[0].classList.add('active-slide');

    element.classList.add('keen-slider');

    const slider = new KeenSlider(element, {
      loop: true,
      created: function(instance) {
        const dotsWrapper = element.parentNode.querySelector('.testimonials--dots');
        items.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.setAttribute('aria-label', 'Testimonial button');
          dot.classList.add('dot');
          if (index === 0) {
            dot.classList.add('dot--active');
          }
          dotsWrapper.appendChild(dot);
          dot.addEventListener('click', function() {
            instance.moveToSlide(index);
          });
        })
      },
      afterChange(instance) {
        const slide = instance.details().relativeSlide;
        const dots = element.parentNode.querySelectorAll('.dot');
        dots.forEach((dot, index) => {
          index === slide
            ? dot.classList.add("dot--active")
            : dot.classList.remove("dot--active");
        })
      }
    });

  }
}

DrupalBehavior.register('summit_theme', 'Testimonials', Testimonials);